import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";

@Injectable()
export class OrderEngineService {
	constructor(private httpService: HttpService) { }


}
